import { __exports as TokenReplace } from './_virtual-TokenReplace.js';
import { __require as requireInteropRequireDefault } from './node_modules-@babel-runtime-helpers-interopRequireDefault.js';
import React from 'react';
import { __require as requireBuild } from './vp-js-token-engine-build-index.js';

var hasRequiredTokenReplace;

function requireTokenReplace () {
	if (hasRequiredTokenReplace) return TokenReplace;
	hasRequiredTokenReplace = 1;

	var _interopRequireDefault = requireInteropRequireDefault();
	Object.defineProperty(TokenReplace, "__esModule", {
	  value: true
	});
	TokenReplace.default = void 0;
	var React$1 = _interopRequireWildcard(React);
	var _vpJsTokenEngine = _interopRequireDefault(requireBuild());
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	let TokenReplace$1 = class TokenReplace extends React$1.Component {
	  constructor() {
	    super(...arguments);
	    this.tokenEngine = new _vpJsTokenEngine.default();
	  }
	  render() {
	    return this.tokenEngine.replace(this.props.tokenizedText, this.props.contextVariables);
	  }
	};
	TokenReplace.default = TokenReplace$1;
	
	return TokenReplace;
}

export { requireTokenReplace as __require };
//# sourceMappingURL=vp-tokenized-fragment-build-TokenReplace.js.map
